import React from 'react';

const Video = (props) => {
    const videoUrl = `https://www.youtube.com/embed/${props.id}?si=QJro2oB8NNDZ851L`;
    return (
        <div style={{ height: '350px' }}>
            <iframe
                className="w-full h-full"
                src={videoUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen={false}
                controls={false}
                rel="0"
                style={{
                    width: 560,
                    height: 315,
                    margin: "0 auto"
                }}
            
            ></iframe>
        </div>
    );
};

export default Video;
